import {
  mixpanelPopupCTAEvent,
  subscriptionSelectedMixPanel
} from 'src/components/ConsumptionBuyPlanPopup/MixpanelHelper';
import {
  getDisplayPlansData,
  getDisplayPlansMetaData
} from 'src/services/apiRequests/SubscriptionService';
import fetchGuestUserRegistrationToken from 'src/services/consumption/revised-subscription-journey/guest-user-registration-service';
import SimpleStore from 'src/store/SimpleStore';
import { MIXPANEL_BUY_PREMIUM } from 'src/utils/analytics/mixpanel/mixpanelConstants';
import {
  getLocalStorage,
  setLocalStorage
} from 'src/utils/browserStorageHandler';
import { HTTP_URL_PARAMS } from 'src/utils/constants/HttpMethodsConstants';
import {
  CONSUMPTION_PAYMENT_JOURNEY_PATH,
  IS_CONSUMPTION_PAYMENT_JOURNEY,
  USER_TYPE
} from 'src/utils/constants/localStorageConstants';
import { HamburgerMenuLinks } from 'src/utils/constants/RouterConstants';
import { UserTypes } from 'src/utils/constants/stringConstants';
import { FeatureFlagConstants } from 'src/utils/constants/utilConstants';
import { getFeatureFlagConfig } from 'src/utils/RemoteConfig';
import {
  buyPlan,
  getCurrentPlan
} from 'src/utils/SubscriptionHelper/SubscriptionHelper';

const redirectToSubscriptionPage = () => {
  window.location.assign(HamburgerMenuLinks.BUY_PLAN);
};

export const getRsjFeatureFlag = (remoteConfig: any) => {
  const { enabled, payload } = getFeatureFlagConfig(
    remoteConfig,
    FeatureFlagConstants.FEATURE_GUEST_SUBSCRIPTION_JOURNEY
  );
  return enabled ? payload : false;
};

export const handleBuyClickOnBanner = async (remoteConfig: any) => {
  const userType = getLocalStorage(USER_TYPE);

  const plansData = await getDisplayPlansData();
  const activePromos = {};
  const promoCode = '';
  const countryCode = SimpleStore.get(HTTP_URL_PARAMS.COUNTRY_CODE);
  const rsjFeatureFlag = getRsjFeatureFlag(remoteConfig);
  if (userType === UserTypes.GUEST && rsjFeatureFlag) {
    await fetchGuestUserRegistrationToken();
  }
  if (!plansData) return redirectToSubscriptionPage();

  //Assert: will give a response
  const plansMetaData = await getDisplayPlansMetaData();

  const { default_plan } = plansData;
  const currentPlan = getCurrentPlan(plansData, default_plan);

  buyPlan(
    plansData,
    plansMetaData,
    currentPlan,
    default_plan,
    activePromos,
    promoCode,
    countryCode,
    null,
    true
  );

  // set indicator in localstorage for consumption buy plan journey
  if (rsjFeatureFlag) {
    setLocalStorage(IS_CONSUMPTION_PAYMENT_JOURNEY, true);
  }
  setLocalStorage(CONSUMPTION_PAYMENT_JOURNEY_PATH, window.location.pathname);

  // analytics
  mixpanelPopupCTAEvent(MIXPANEL_BUY_PREMIUM);
  subscriptionSelectedMixPanel(currentPlan, MIXPANEL_BUY_PREMIUM);

  if (userType === UserTypes.GUEST && !rsjFeatureFlag) {
    window.location.href = '/myaccount/account-info';
  } else {
    window.location.href = '/myaccount/payment';
  }
  // redirect to payments page
};
